<div class="py-12 bg-base-200 min-h-screen flex items-center justify-center px-4">
  <div class="max-w-4xl w-full">
    <h2 class="text-3xl font-bold text-center mb-10">Contactez-nous</h2>

    <div class="grid grid-cols-1 md:grid-cols-3 gap-6">

      <div class="card bg-base-100 shadow-xl hover:shadow-2xl transition-shadow">
        <div class="card-body items-center text-center">
          <div class="text-primary mb-2">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-10 w-10" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
            </svg>
          </div>
          <h3 class="card-title">Email</h3>
          <p class="text-sm opacity-70">Réponse sous 24h</p>
          <div class="card-actions mt-4">
            <a [href]="'mailto:' + email" class="btn btn-primary btn-sm">Nous écrire</a>
          </div>
        </div>
      </div>

      <div class="card bg-base-100 shadow-xl hover:shadow-2xl transition-shadow">
        <div class="card-body items-center text-center">
          <div class="text-secondary mb-2">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-10 w-10" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
            </svg>
          </div>
          <h3 class="card-title">Téléphone</h3>
          <p class="font-bold">{{ telephone }}</p>
          <div class="card-actions mt-4">
            <a [href]="'tel:+687' + telephone.replaceAll('.','')" class="btn btn-secondary btn-sm">Appeler</a>
          </div>
        </div>
      </div>

      <div class="card bg-base-100 shadow-xl hover:shadow-2xl transition-shadow border-2 border-info/20">
        <div class="card-body items-center text-center">
          <div class="text-info mb-2">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-10 w-10" fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 2C6.477 2 2 6.145 2 11.258c0 2.908 1.462 5.503 3.746 7.231V22l3.355-1.839c.894.248 1.832.383 2.801.383 5.523 0 10-4.145 10-9.258C22 6.145 17.523 2 12 2zm1.061 12.553l-2.554-2.724-4.99 2.724 5.484-5.83 2.612 2.724 4.932-2.724-5.484 5.83z"/>
            </svg>
          </div>
          <h3 class="card-title">Messenger</h3>
          <p class="text-sm opacity-70">Discussion instantanée</p>
          <div class="card-actions mt-4">
            <a [href]="messengerLink" target="_blank" class="btn btn-info text-white btn-sm">Démarrer le chat</a>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
